import { render, staticRenderFns } from "./OtnSingleTemplate.vue?vue&type=template&id=de1ae7d2&"
import script from "./OtnSingleTemplate.vue?vue&type=script&lang=js&"
export * from "./OtnSingleTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports